<template>
    <div>
        <button-white v-show="!loading" @click="create(day)">Schreibtisch freigeben</button-white>
        <loading v-show="loading"></loading>
    </div>
</template>

<script>
import ButtonWhite from "../components/UI/ButtonWhite.vue"
import Loading from "../components/UI/Loading.vue"

export default {
    name: "BookingRelease",

    components: {
        ButtonWhite,
        Loading,
    },

    data: () => ({
        loading: false,
    }),

    props: ['userId', 'day'],

    mounted() {
        this.open();
    },

    methods: {

        open() {
            this.$http.get(`/admin/users/${this.userId}/days`).then(response => {
                this.releases = response.data.data;
            }).catch(error => {
                this.$root.$emit('error', error);
            })
        },

        create(day) {
            this.loading = true;
            this.$http.post(`/admin/users/${this.userId}/days`, {
                day: day,
            }).then(() => {
                this.loading = false;
                this.$emit('reload');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },

        /*remove(day) {
            const release = this.releases.find(r => r.day === day);
            const id = release.id;
            this.loading = true;
            this.$http.delete(`/admin/users/${this.user.id}/days/${id}`).then(() => {
                this.open();
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },*/
    }

}
</script>

<style>

</style>